import { Button } from '@/components/Button'
import * as M from '@/materials'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from 'styled-components/macro'
import { useImmer } from 'use-immer'
import { default as PopularVote } from './PopularVote'

const Root = 'div'

interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  popularVotes: Array<{ id: string; date: Date }>
}

function Renderer(props: Props) {
  const { popularVotes, ...rest } = props

  const [state, mutate] = useImmer({
    expanded: false,
  })

  if (popularVotes.length === 0) {
    return null
  }

  const visibleItems = state.expanded ? popularVotes : popularVotes.slice(0, 2)

  return (
    <Root css={styles.root as any} {...rest}>
      <div css={styles.heading as any}>
        <FormattedMessage id="components.Archive.heading" defaultMessage="Abstimmungsarchiv" />
      </div>

      {visibleItems.map((x, i) => (
        <div css={styles.wrapper as any} key={i}>
          <PopularVote popularVoteId={x.id} archive first={i === 0} />
        </div>
      ))}

      {(() => {
        if (visibleItems.length < popularVotes.length) {
          return (
            <div css={styles.loadMoreContainer as any}>
              <Button
                css={styles.loadMoreButton as any}
                onClick={() => {
                  mutate((draft) => {
                    draft.expanded = true
                  })
                }}
              >
                <FormattedMessage id="components.Archive.older-content" defaultMessage="Älterer Inhalt" />
              </Button>
            </div>
          )
        } else {
          return null
        }
      })()}
    </Root>
  )
}

const styles = {
  root: css``,

  heading: css`
    ${M.fontHeading3_};
    text-transform: uppercase;

    margin-bottom: 20px;
  `,

  wrapper: css`
    margin-bottom: 60px;

    @media only screen and (min-width: 1072px) {
      margin-bottom: 80px;
    }
  `,

  loadMoreContainer: css`
    display: flex;
    justify-content: center;

    margin-bottom: 20px;
  `,
  loadMoreButton: css`
    min-width: 156px;
  `,
}

export default React.memo(Renderer)
